module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "Wisconsin.e1aaf113.webp";